export const MAX_IMAGES = 10;
export const MAX_IMAGE_SIZE_BYTES = 5 * 1024 * 1024; // 5MB
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png'] as const;
export type AllowedImageType = (typeof ALLOWED_IMAGE_TYPES)[number];

export function validateImageCount(count: number): string | null {
  if (count < 1) return 'At least 1 image is required.';
  if (count > MAX_IMAGES) return `Maximum ${MAX_IMAGES} images allowed.`;
  return null;
}

export function validateImageContentType(contentType: string): string | null {
  if (!(ALLOWED_IMAGE_TYPES as readonly string[]).includes(contentType)) {
    return `Unsupported image type: ${contentType}. Only JPEG and PNG are supported.`;
  }
  return null;
}

export function validateImageSizeBytes(sizeBytes: number): string | null {
  if (sizeBytes > MAX_IMAGE_SIZE_BYTES) {
    const maxMB = MAX_IMAGE_SIZE_BYTES / (1024 * 1024);
    return `Image exceeds ${maxMB}MB limit.`;
  }
  return null;
}
